import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxSwitchModule } from 'devextreme-angular';

@Component({
  selector: 'dk-switch-button',
  standalone: true,
  imports: [CommonModule,DxSwitchModule],
  templateUrl: './dk-switch-button.component.html',
  styleUrls: ['./dk-switch-button.component.scss'],
})
export class DkSwitchButtonComponent implements OnInit {
  @Input() label = "";
  @Input() data = 0;
  @Input() readOnly = false;
  @Output() resultSwitch = new EventEmitter<any>();

  ngOnInit(): void {
  }

  valueChange(e:any){
    if(e.value) this.data = 1;
    else this.data = 0
    this.resultSwitch.emit(this.data)
  }
}
